import { ActiveLanguage } from 'shared/vidio_helpers';
import Blocker from 'components/shared/Blocker';
import LoginBottomsheet from 'components/mobile/LoginBottomsheet/LoginBottomsheet';

export default class Login {
  constructor(element) {
    this.element = element;
    let loginBottomsheetElement = document.getElementById('login-bottomsheet');
    if (loginBottomsheetElement) {
      this.loginBottomsheet = new LoginBottomsheet({ element: loginBottomsheetElement });
    }
  }

  type() {
    return 'login_blocker';
  }

  show() {
    let lang = ActiveLanguage.get();
    let { message: title, button: buttonText } = window.Locale[lang].content_gating_banner.login;
    let currentPage = new URL(window.location.href);
    currentPage.searchParams.set('t', window.contentGatingActionRequiredAfter);
    let returnLink = encodeURIComponent(currentPage.pathname + currentPage.search);
    let buttons = [{
      text: buttonText,
      link: `/users/login?user_return_to=${returnLink}&onboarding_source=login_blocker`,
      align: 'horizontal',
      theme: 'red'
    }]

    let loginBlocker = new Blocker({
      title,
      buttons,
      closable: false,
      element: this.element,
    });
    loginBlocker.show();

    if (this.loginBottomsheet) {
      this.loginBottomsheet.init();
      this.loginBottomsheet.show();
    }

    this.element.classList.remove('hide');
  }
}
